/* Header.jsx */
import React from 'react'
// CSS
import styled from 'styled-components'
// Router
import { Link } from 'react-router-dom'

const Header = ({onPage}) => {
  return (
      <Felx>
        <Wrap>
            <Container to={'/'} onPage={onPage}>
                <p>한국 밈 사전</p>
                <p>K-MEME DICTIONARY</p>
                <Underline></Underline>
            </Container>
            <Container to={'/detail/'} onPage={!onPage}>
                <p>추가하기</p>
                <p>ADD K-MEME </p>
                <Underline></Underline>
            </Container>
            <img style={{width:"200px", height:'100%', zIndex:'-1'}} src="https://j.gifs.com/81yl7r.gif" alt="" />
            <span>BGM IS READY</span>
        </Wrap>
    </Felx>
  )
}

export default Header

const Felx = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;


const Wrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 3px solid var(--white);
    width: 80%;
    span{
        font-size: 1.5rem;
        margin-bottom: 30px;
    }
`;

const Container = styled(Link)`
    text-align: center;
    margin: 0 0 0 50px;
    font-size: 2rem;
    padding: 60px;
    font-weight: 700;
    cursor: pointer;
    &:hover{
        background-color: white;
        color:black;
    }
    background-color: ${props => props.onPage? "#fff" : "#000"};
    color: ${props => props.onPage? "#000" : "#fff"};
    @media screen and (max-width: 700px) {
      p:nth-child(2){
          display: none;
      }
    }
`;

const Underline = styled.div`
    width: 500;
    height: 1px;
    background-color: var(--white);
`;